import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

export function Signup() {
    const navigate = useNavigate();

    useEffect(() => {
        // تحويل المستخدم فوراً لصفحة تسجيل الدخول
        navigate('/login', { replace: true });
    }, [navigate]);

    return (
        <div style={{ 
            display: 'flex', 
            justifyContent: 'center', 
            alignItems: 'center', 
            height: '100vh',
            background: '#0a0a0a',
            color: '#fff',
            fontFamily: 'sans-serif'
        }}>
            <p>Redirecting to login...</p>
        </div>
    );
}
